<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择设备"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="equipments">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="名称">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="型号">
            <el-input v-model.trim="filter.model" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="no" align="center" label="编号"/>
      <el-table-column prop="name" align="center" label="名称"/>
      <el-table-column prop="model" align="center" label="型号"/>
      <el-table-column prop="location" align="center" label="位置"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name:"EquipmentSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        filter: {
          no: "",
          name: "",
          model: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
